import { Component, OnInit } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ApiService} from '../../../../../../projects/accounting/src/public_api';

@Component({
  selector: 'app-point-used-detail',
  templateUrl: './point-used-detail.component.html',
  styleUrls: ['./point-used-detail.component.scss']
})
export class PointUsedDetailComponent implements OnInit {
  data = null;
  time:any = null;
  loading = false;

  constructor(
      public bsModal: BsModalRef,
      private api: ApiService
  ) { }

  ngOnInit() {
    this.load();
  }
  load(){

    this.loading = true;
    this.api.pointHistory(this.time).subscribe( rs => {
      this.loading = false;
      if(rs && rs.succeed){
        rs.data = rs.data.filter( i => i.Used > 0);
        rs.data.forEach( i => {
          i.ShopID = i.Subject[0];
          i.Address = i.Subject[1];
        });
        this.data  = rs.data;
      }
    })
  }
  generateAddress(string){
    let first = string.split(',')[0];
    return '<b>' + first + '</b><br><small>' + string.substr(first.length + 1) + '</small>';
  }
  close(){
    this.bsModal.hide()
  }
}
